export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  imageUrl: string;
  author: string;
  publishDate: string;
  viewCount: number;
  commentCount: number;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const articles: Article[] = [
  {
    id: '1',
    title: '某知名女星深夜密会神秘男子，疑似新恋情曝光，男方身份引猜测',
    excerpt: '近日有媒体拍到某知名一线女星深夜与一名神秘男子共同返回住所，两人举止亲密，疑似正在热恋中。该女星此前一直对外宣称单身，此次被拍引发网友热议。',
    content: `<p>近日，有知名娱乐媒体拍到一线女星林某某深夜与一名神秘男子在街边拥抱热吻，随后两人一同返回女星住所，直至次日中午才先后离开。该消息一出，立刻在网络上引发轩然大波。</p>
<p>据知情人士透露，该神秘男子并非圈内人士，而是一位低调的企业家，身价不菲。两人交往已有数月，感情稳定。此前林某某在多个场合公开表示自己是单身状态，此次"打脸"被不少网友嘲讽。</p>
<p>有网友扒出该男子身份，疑似某互联网公司创始合伙人，已婚并育有一子。若此消息属实，林某某恐将陷入"小三"争议。目前林某某的经纪团队尚未对此事做出回应。</p>
<p>娱乐圈资深评论人王某表示："现在的明星越来越不把粉丝当回事，公开说谎已成常态。这种行为对青少年粉丝的价值观影响很不好。"</p>
<p>截至发稿前，相关话题已登上微博热搜第一，阅读量突破3亿。吃瓜群众纷纷表示"好瓜，继续蹲后续"。</p>`,
    category: 'yulequan',
    categoryName: '娱乐圈',
    imageUrl: 'https://readdy.ai/api/search-image?query=Paparazzi%20night%20scene%20of%20a%20famous%20actress%20walking%20with%20mysterious%20man%20on%20dimly%20lit%20street%2C%20blurry%20candid%20photography%20style%2C%20dramatic%20moody%20atmosphere%2C%20warm%20street%20lights%2C%20tabloid%20aesthetic&width=800&height=500&seq=article-1&orientation=landscape',
    author: '黑料君',
    publishDate: '2026-08-06',
    viewCount: 328000,
    commentCount: 12500,
    tags: ['林某某', '恋情曝光', '小三争议', '娱乐圈八卦'],
    isHot: true,
    isNew: true,
  },
  {
    id: '2',
    title: '顶流男星被曝片场耍大牌，剧组工作人员集体爆料：太难伺候了',
    excerpt: '某顶流男星近日被多名剧组工作人员匿名爆料，称其在片场耍大牌、随意改戏、迟到早退，甚至对工作人员恶语相向，引发业内热议。',
    content: `<p>日前，有自称是《XX风云》剧组的工作人员在社交平台匿名爆料，直指剧中男主角、某顶流男星张某在片场行为恶劣，严重影响剧组拍摄进度。</p>
<p>据爆料者称，张某在拍摄期间经常迟到，最严重的一次让全组等了他四个小时。到场后不仅没有道歉，反而嫌弃化妆间太小、伙食太差。"每天都像伺候大爷一样，稍微不满意就摆脸色。"</p>
<p>另一位工作人员透露，张某还经常擅自修改剧本，对编剧的原创内容指手画脚，导致拍摄计划屡屡被打乱。"编剧老师气得当场摔了剧本，但是投资人点名要他，大家只能忍着。"</p>
<p>更有消息称，张某对群众演员极其不尊重，曾当众训斥一位年过六旬的老演员"会不会演戏"，引发在场人员不满。</p>
<p>截至目前，张某工作室已发表声明否认相关传闻，称"均为不实信息，将保留追究法律责任的权利"。但网友们纷纷表示"无风不起浪"，期待更多实锤。</p>`,
    category: 'yulequan',
    categoryName: '娱乐圈',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20set%20drama%20scene%2C%20angry%20crew%20members%20arguing%20on%20movie%20set%2C%20dramatic%20lighting%2C%20tense%20atmosphere%2C%20behind%20the%20scenes%20movie%20production%2C%20cinematic%20moody%20photography&width=800&height=500&seq=article-2&orientation=landscape',
    author: '八卦小能手',
    publishDate: '2026-08-05',
    viewCount: 256000,
    commentCount: 9800,
    tags: ['张某', '耍大牌', '片场风波', '顶流翻车'],
    isHot: true,
    isNew: false,
  },
  {
    id: '3',
    title: '知名网红直播翻车，假货风波持续发酵，品牌方紧急解约',
    excerpt: '拥有千万粉丝的知名带货网红"小美姐"近日因直播间售卖的化妆品被鉴定为假货而陷入舆论漩涡，多个品牌方宣布与其解约。',
    content: `<p>近日，知名网红"小美姐"（粉丝量1200万+）在直播间销售的高端护肤品被多位消费者送检鉴定，结果显示产品成分与正品不符，确认为假货。此事一经曝光，迅速引发全网关注。</p>
<p>据受害者王女士描述，她在小美姐直播间购买的一套国际品牌护肤品套装，花费近3000元，但使用后出现严重过敏反应。送检后被告知产品中含有违禁成分。"我在她直播间买了两年东西了，没想到会被骗。"</p>
<p>事件发酵后，已有超过500名消费者组建维权群，累计涉及金额超过200万元。多个曾与小美姐合作的品牌方紧急发布声明，宣布与其终止合作关系。</p>
<p>平台方面表示已介入调查，小美姐的直播间目前已被暂停。但小美姐本人始终未正面回应此事，仅在个人社交账号发布了一条"清者自清"的动态后便销声匿迹。</p>
<p>有业内人士分析称，直播带货行业长期存在供应链混乱的问题，部分主播为追求高佣金而忽视选品质量，"这次事件可能只是冰山一角"。</p>`,
    category: 'wanghong',
    categoryName: '网红',
    imageUrl: 'https://readdy.ai/api/search-image?query=Livestreaming%20studio%20with%20beauty%20products%20scattered%20on%20table%2C%20dramatic%20red%20warning%20aesthetic%2C%20counterfeit%20cosmetics%20theme%2C%20dark%20moody%20lighting%2C%20investigative%20journalism%20style&width=800&height=500&seq=article-3&orientation=landscape',
    author: '黑料君',
    publishDate: '2026-08-04',
    viewCount: 412000,
    commentCount: 18700,
    tags: ['小美姐', '假货', '直播带货', '消费者维权'],
    isHot: true,
    isNew: false,
  },
  {
    id: '4',
    title: '百万粉丝博主被爆学历造假，人设崩塌，粉丝集体脱粉',
    excerpt: '以"清华学霸"人设走红的某教育类博主，被网友实锤学历造假，实际仅为普通二本毕业，其创办的"学习方法课"也被指抄袭。',
    content: `<p>以"清华学霸"、"学习方法大师"人设吸粉300万的某教育博主李某某，近日被网友扒出其学历信息造假。据核查，李某某并非清华大学毕业生，实际毕业院校为某普通二本学院。</p>
<p>爆料者提供了详实的证据链，包括学信网截图、校友证词等，证实李某某从未在清华大学就读过。而其此前在直播中多次以"清华学习方法"为卖点推销课程，售价高达2999元。</p>
<p>更令人震惊的是，多名购买过其课程的学员反映，课程内容大量抄袭国外公开课和畅销书，原创度极低。"花了三千块买了个搬运工的视频，太坑了。"</p>
<p>事件曝光后，李某某的粉丝数在一周内暴跌80万。大量粉丝表示"被欺骗了感情和金钱"，正在组织集体退款。</p>
<p>有律师表示，李某某的行为涉嫌虚假宣传和消费欺诈，消费者有权要求退一赔三。"在网络上打造虚假人设赚取利益，已经触及法律红线。"</p>`,
    category: 'wanghong',
    categoryName: '网红',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fake%20diploma%20and%20certificates%20on%20a%20desk%20with%20dramatic%20shadow%20lighting%2C%20education%20scam%20concept%2C%20dark%20academic%20aesthetic%2C%20investigative%20mood%2C%20warm%20but%20ominous%20atmosphere&width=800&height=500&seq=article-4&orientation=landscape',
    author: '八卦小能手',
    publishDate: '2026-08-03',
    viewCount: 189000,
    commentCount: 7600,
    tags: ['学历造假', '人设崩塌', '教育博主', '课程退款'],
    isHot: true,
    isNew: false,
  },
  {
    id: '5',
    title: '某选秀冠军被曝与经纪公司对簿公堂，天价违约金惹争议',
    excerpt: '三年前选秀节目冠军陈某近日被曝与经纪公司闹翻，公司要求其赔偿高达5000万的违约金，而陈某反诉公司长期压榨艺人。',
    content: `<p>据可靠消息，某大型选秀节目冠军陈某某已于上月正式向法院提起诉讼，要求与其经纪公司解除合约，并指控该公司存在多项违规行为。</p>
<p>陈某某在诉状中详细列举了经纪公司的"七宗罪"：恶意克扣演出收入、强制安排过度工作、限制人身自由、未经允许私自签订商业代言等。据其律师透露，陈某某近三年为公司创造了超过2亿的收入，但本人实际到手不足500万。</p>
<p>而经纪公司方面则提起反诉，要求陈某某支付5000万违约金，理由是陈某某私自接洽商业活动，严重违反了双方签订的独家经纪协议。</p>
<p>此案在娱乐圈引发巨大震动。多位艺人私下表示，娱乐圈的"霸王合同"问题由来已久，很多年轻艺人被"卖身契"捆住多年，敢怒不敢言。</p>
<p>目前案件正在审理中，法院已冻结陈某某名下部分资产。业内人士预测，此案的结果可能对整个经纪行业产生深远影响。</p>`,
    category: 'mingxing',
    categoryName: '明星',
    imageUrl: 'https://readdy.ai/api/search-image?query=Courtroom%20scene%20with%20contract%20dispute%20drama%2C%20legal%20documents%20and%20gavel%20on%20table%2C%20dramatic%20lighting%2C%20tense%20atmosphere%2C%20legal%20drama%20aesthetic%2C%20warm%20dark%20tones&width=800&height=500&seq=article-5&orientation=landscape',
    author: '黑料君',
    publishDate: '2026-08-02',
    viewCount: 201000,
    commentCount: 8900,
    tags: ['选秀冠军', '天价违约金', '经纪合约', '艺人维权'],
    isHot: false,
    isNew: false,
  },
  {
    id: '6',
    title: '当红小生私生活混乱被爆实锤，多名女性公开聊天记录',
    excerpt: '凭借古装剧爆红的某小生被多名女性联合曝光，指控其同时与多人保持暧昧关系，并通过社交软件物色新目标，私生活极为混乱。',
    content: `<p>近日，一位自称与当红小生吴某交往过的女性在社交平台公开发文，指控吴某在与她交往期间同时与其他多名女性保持暧昧关系，并曝光了大量聊天记录截图作为证据。</p>
<p>该女性在长文中写道，她与吴某于2025年初通过朋友介绍相识，随后确立了恋爱关系。然而在交往的半年中，她逐渐发现吴某的行为异常，最终通过查看手机发现吴某同时与至少五名女性保持着不同寻常的关系。</p>
<p>爆料文章发出后，陆陆续续又有三位女性站出来，晒出与吴某的聊天记录，内容令人咋舌。有网友总结出吴某"多线操作"的时间线，堪称"时间管理大师"。</p>
<p>吴某的粉丝群体出现严重分化，一部分粉丝坚定维护偶像，认为聊天记录可以伪造；大部分路人网友则认为"锤太实了，没法洗"。</p>
<p>吴某工作室当晚发布声明，称"相关聊天记录系恶意剪辑拼凑，已报警处理"。但该声明被网友吐槽"模板化公关，毫无诚意"。</p>`,
    category: 'mingxing',
    categoryName: '明星',
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20with%20chat%20messages%20displayed%20on%20screen%2C%20dark%20dramatic%20lighting%2C%20scandal%20exposure%20concept%2C%20mysterious%20atmosphere%2C%20warm%20amber%20glow%2C%20tabloid%20investigative%20style&width=800&height=500&seq=article-6&orientation=landscape',
    author: '八卦小能手',
    publishDate: '2026-08-01',
    viewCount: 356000,
    commentCount: 15200,
    tags: ['吴某', '私生活', '聊天记录', '多人爆料'],
    isHot: false,
    isNew: false,
  },
  {
    id: '7',
    title: '电竞圈再爆丑闻，知名选手涉嫌参与假赛被联盟调查',
    excerpt: '某知名电竞俱乐部主力选手被曝涉嫌参与外围博彩和假赛，赛事联盟已正式介入调查。该选手此前以稳定发挥著称，消息一出震惊整个电竞圈。',
    content: `<p>电子竞技圈近日再掀波澜。据知情人士爆料，某顶级战队的核心选手"Feng"在最近几个月的多场比赛中存在异常操作，涉嫌参与外围博彩操控比赛结果。</p>
<p>有数据分析师对"Feng"近期的比赛录像进行了详细复盘，指出其在三场关键比赛中的多个"低级失误"绝非正常职业选手会犯的错误。这些失误直接导致了比赛失利，而每次失误的时间点恰好与外围盘口的赔率波动吻合。</p>
<p>更令人震惊的是，有网友挖出"Feng"的社交小号，发现其与某外围庄家的聊天记录，内容涉及具体的假赛安排和报酬分配。这些截图正在以极快的速度在电竞社区传播。</p>
<p>赛事联盟官方已发布公告，确认已收到相关举报并启动调查程序。联盟表示对任何破坏竞技公平性的行为采取零容忍态度，一旦查实将处以终身禁赛。</p>
<p>"Feng"所在的俱乐部暂时未发表正式声明，但据内部人士透露，俱乐部已经暂停了"Feng"的全部训练和比赛安排。</p>`,
    category: 'dianjing',
    categoryName: '电竞圈',
    imageUrl: 'https://readdy.ai/api/search-image?query=Esports%20gaming%20arena%20with%20dramatic%20red%20and%20dark%20lighting%2C%20professional%20gamer%20at%20computer%2C%20tense%20competitive%20atmosphere%2C%20investigation%20theme%2C%20moody%20cinematic%20photography&width=800&height=500&seq=article-7&orientation=landscape',
    author: '黑料君',
    publishDate: '2026-07-30',
    viewCount: 187000,
    commentCount: 9200,
    tags: ['电竞', '假赛', '外围博彩', '联盟调查'],
    isHot: true,
    isNew: false,
  },
  {
    id: '8',
    title: '某知名游戏主播被平台永久封禁，背后原因令人震惊',
    excerpt: '在直播平台拥有800万粉丝的某知名游戏主播突然被全平台封禁，官方给出的理由是"严重违规"，但有消息称真正原因与税务问题有关。',
    content: `<p>近日，拥有800万粉丝的知名游戏主播"大山哥"突然在所有直播平台被永久封禁，其社交账号也一并被注销。官方公告仅模糊地表示"严重违反平台规则"，但未说明具体原因。</p>
<p>据多位接近平台的消息人士透露，"大山哥"被封的真正原因是税务问题。据悉，其近三年直播收入超过1.5亿元，但存在严重的偷税漏税行为。税务部门已介入调查，相关证据较为充分。</p>
<p>此外，还有爆料称"大山哥"与多家涉嫌网络赌博的境外平台有合作关系，通过直播引流方式为这些平台招揽用户，从中非法获利数千万元。</p>
<p>"大山哥"的粉丝群体目前处于混乱状态，部分粉丝不相信这些传闻，仍坚持"等待官方辟谣"；更多粉丝则表示了失望和愤怒。</p>
<p>有业内律师分析认为，若上述情况属实，"大山哥"可能面临巨额罚款甚至刑事处罚。"网络直播不是法外之地，再大的主播也不能触碰法律底线。"</p>`,
    category: 'dianjing',
    categoryName: '电竞圈',
    imageUrl: 'https://readdy.ai/api/search-image?query=Gaming%20streamer%20setup%20with%20computer%20monitors%20showing%20banned%20message%2C%20dark%20room%20with%20dramatic%20red%20lighting%2C%20ban%20concept%2C%20mysterious%20atmosphere%2C%20digital%20drama%20aesthetic&width=800&height=500&seq=article-8&orientation=landscape',
    author: '八卦小能手',
    publishDate: '2026-07-29',
    viewCount: 298000,
    commentCount: 13500,
    tags: ['游戏主播', '封禁', '税务问题', '网络赌博'],
    isHot: false,
    isNew: false,
  },
  {
    id: '9',
    title: '网红餐厅后厨卫生状况堪忧，顾客吃出异物，市监局介入调查',
    excerpt: '一家在某平台评分高达4.8的网红餐厅被顾客曝出在菜品中吃出蟑螂，随后有前员工匿名披露其后厨卫生条件极其恶劣，引发社会广泛关注。',
    content: `<p>日前，一位顾客在某点评平台发文称，在一家评分4.8分的网红餐厅用餐时，在菜品中吃出了一只完整的蟑螂。该顾客当场拍照取证并向店家投诉，却遭到店家推诿扯皮。</p>
<p>该帖子迅速在网络上传播开来。随后，多名自称曾在该餐厅工作的前员工匿名站出来，披露了更加令人震惊的内幕。据他们描述，该餐厅后厨长期存在使用过期食材、重复使用老油、老鼠蟑螂横行等严重卫生问题。</p>
<p>"那些看起来精致的网红菜，很多都是前一天剩下的回锅的。厨房的蟑螂多到可以直接在墙上看到它们在爬。"一位前员工如此说道。</p>
<p>事件持续发酵后，当地市场监督管理局已派出执法人员对该餐厅进行突击检查。初步检查结果显示，该餐厅确实存在多项卫生违规行为，已被责令停业整顿。</p>
<p>此事在网络上引发了对整个"网红餐饮"行业的质疑。有消费者权益专家呼吁，平台应该对入驻商家的资质和卫生状况进行更严格的把关，而不是只看表面评分。</p>`,
    category: 'shehui',
    categoryName: '社会热点',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dirty%20restaurant%20kitchen%20with%20poor%20hygiene%20conditions%2C%20food%20safety%20violation%2C%20dramatic%20investigative%20photography%2C%20dark%20grimy%20atmosphere%2C%20health%20inspection%20theme&width=800&height=500&seq=article-9&orientation=landscape',
    author: '黑料君',
    publishDate: '2026-07-28',
    viewCount: 234000,
    commentCount: 11200,
    tags: ['网红餐厅', '食品安全', '市监局', '卫生问题'],
    isHot: false,
    isNew: false,
  },
  {
    id: '10',
    title: '知名企业家被曝财务造假，股价单日暴跌40%，投资者血本无归',
    excerpt: '某知名上市公司创始人兼CEO被做空机构指控财务造假，报告发布后该公司股价单日暴跌40%，市值蒸发超百亿，无数投资者蒙受巨大损失。',
    content: `<p>国际知名做空机构"浑水"日前发布了一份长达80页的做空报告，直指某知名科技上市公司存在系统性财务造假行为。该报告详细列举了包括虚增营收、隐瞒关联交易、伪造客户合同等多条指控。</p>
<p>报告发布当日，该公司股价开盘即暴跌40%，触及熔断机制。据估算，仅一个交易日内市值蒸发超过120亿元，大量中小投资者血本无归。社交媒体上满是投资者的愤怒控诉和哭诉。</p>
<p>该公司创始人兼CEO赵某某在股价暴跌后紧急召开新闻发布会，称做空报告"完全是无中生有"，并表示将动用自有资金进行增持以稳定市场信心。然而其增持金额仅为500万元，被投资者嘲讽为"杯水车薪"。</p>
<p>证监会随后宣布已对该公司启动立案调查，并暂停其股票交易。多位证券律师表示，已经开始接受投资者委托，准备发起集体诉讼。</p>
<p>有财经评论员指出，近年来类似财务造假事件频发，反映出上市公司监管仍存在改进空间。"保护中小投资者权益不能只停留在口号上。"</p>`,
    category: 'shehui',
    categoryName: '社会热点',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stock%20market%20crash%20visualization%20with%20falling%20red%20charts%20and%20graphs%2C%20financial%20scandal%20concept%2C%20dramatic%20dark%20office%20setting%2C%20business%20crisis%20atmosphere%2C%20investigative%20journalism%20style&width=800&height=500&seq=article-10&orientation=landscape',
    author: '八卦小能手',
    publishDate: '2026-07-26',
    viewCount: 345000,
    commentCount: 16800,
    tags: ['财务造假', '股价暴跌', '投资者维权', '证监会'],
    isHot: false,
    isNew: false,
  },
  {
    id: '11',
    title: '某女团成员被爆霸凌队友，聊天记录曝光，经纪公司紧急回应',
    excerpt: '近日，某当红女团成员金某被曝长期霸凌队内某位人气较低的成员，大量内部聊天记录被公开，内容令人震惊。经纪公司连夜发布声明回应。',
    content: `<p>韩国某知名女团的中国籍成员金某某近日被推上风口浪尖。有自称是该女团前工作人员的匿名人士公开了大量内部聊天记录，显示金某某长期对队内另一位中国籍成员林某进行语言霸凌和排挤。</p>
<p>曝光的聊天记录中，金某某频繁使用侮辱性语言辱骂林某，包括嘲笑其外貌、唱功和家庭背景。更令人气愤的是，金某某还联合队内其他几名成员一起孤立林某，在练习和演出中故意排挤她。</p>
<p>粉丝们注意到，林某近半年来确实频繁表现出低落情绪，在综艺节目中也常常被边缘化。"当时大家还以为是综艺效果，现在回头看真的很心疼她。"</p>
<p>事件发酵后，该女团所属经纪公司紧急发布声明，称"正在核实相关情况，将尽快给出调查结果"。但这份声明被粉丝认为是在"和稀泥"，要求公司必须严肃处理。</p>
<p>有业内人士透露，韩国偶像团体的内部霸凌问题并不罕见，但因各种利益关系很少被公开。"这种事情的曝光可能只是开始。"</p>`,
    category: 'yulequan',
    categoryName: '娱乐圈',
    imageUrl: 'https://readdy.ai/api/search-image?query=Kpop%20girl%20group%20drama%20backstage%20scene%2C%20members%20with%20tense%20expressions%2C%20dramatic%20split%20lighting%2C%20bullying%20controversy%20theme%2C%20dark%20moody%20atmosphere%2C%20entertainment%20industry%20expose&width=800&height=500&seq=article-11&orientation=landscape',
    author: '黑料君',
    publishDate: '2026-07-25',
    viewCount: 278000,
    commentCount: 14200,
    tags: ['女团', '霸凌', '聊天记录', '韩娱'],
    isHot: false,
    isNew: false,
  },
  {
    id: '12',
    title: '知名歌手被指抄袭，原创音乐人发声维权，网友扒出更多雷同作品',
    excerpt: '某知名原创歌手近期发布的新歌被指多处抄袭国外小众音乐人的作品。原作者已通过社交媒体发声维权，事件持续升级。',
    content: `<p>近日，知名歌手刘某发布的新单曲《夏夜》被乐评人指出其旋律和编曲与一位国外小众音乐人的作品高度雷同。随后有专业音乐人制作了对比视频，雷同程度令人震惊。</p>
<p>国外原作者的粉丝通过社交媒体联系到了这位音乐人。原作者随后公开发文表示："我从未授权任何人使用我的音乐。如果这是抄袭，我将通过法律途径解决。"</p>
<p>更让事态升级的是，在网友们深挖之下，发现刘某过去的多首热门歌曲也存在不同程度的"借鉴"嫌疑，涉及至少五位国外音乐人。有网友制作了"刘某抄袭全纪录"视频，播放量已突破千万。</p>
<p>刘某方面先是沉默了两天，随后由工作室发表声明，称"音乐创作难免会有灵感碰撞，不存在主观抄袭意图"。这份声明被网友戏称为"本年度最佳公关反面教材"。</p>
<p>音乐版权律师表示，如果原作者提起诉讼，刘某可能面临巨额赔偿。"在音乐行业，抄袭是最严重的不端行为之一，对创作者声誉的损害几乎是不可逆的。"</p>`,
    category: 'yulequan',
    categoryName: '娱乐圈',
    imageUrl: 'https://readdy.ai/api/search-image?query=Music%20studio%20with%20sheet%20music%20and%20headphones%2C%20plagiarism%20controversy%20concept%2C%20dramatic%20red%20and%20dark%20lighting%2C%20creative%20theft%20theme%2C%20moody%20atmosphere%2C%20music%20industry%20expose&width=800&height=500&seq=article-12&orientation=landscape',
    author: '八卦小能手',
    publishDate: '2026-07-23',
    viewCount: 198000,
    commentCount: 8700,
    tags: ['音乐抄袭', '版权维权', '原创歌手', '法律纠纷'],
    isHot: false,
    isNew: false,
  },
];